<template>
    <transition name="fade">
        <div class="dialog-overlay"
             @click="onClickOverlay"
             v-show="showDialog">
            <div class="dialog"
                 @click="onMouseDownInDialog"
                 :style="{width: widthStyle(), height: heightStyle()}">
                <div class="container-fluid fill">
                    <div class="row dialog-header justify-content-between">
                        <div class="col-10 my-1 ml-2">
                            <span class="dialog-title">{{title}}</span>
                        </div>
                        <div v-if="!hideCloseButton"
                             class="col-1 mr-2">
                            <div class="close-button"
                                 @click="requestCloseDialog">
                                <div class="close-x-button"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1 no-gutters dialog-content-row">
                        <div class="col no-gutters dialog-content">
                            <slot name="dialogContent"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">

import {defineComponent, onMounted, PropType} from "vue";

export default defineComponent({
    name: "DialogFrame",
    props: {
        showDialog: Boolean,
        width: {
            type: [Number, String],
            default: 400,
        },
        height: {
            type: [Number, String],
            default: 400,
        },
        title: {
            type: String,
            default: "Untitled Dialog"
        },
        onClickClose: {
            type: Function,
            required: true,
        },
        closeByOverlayTouch: {
            type: Boolean,
            default: false,
        },
        hideCloseButton: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {

        let isSM = false

        const requestCloseDialog = () => {
            // console.log("requestCloseDialog");
            if (props.onClickClose && typeof props.onClickClose === "function") {
                props.onClickClose.call({})
            }
        };

        const onMouseDownInDialog = (ev: MouseEvent) => {
            ev.stopPropagation();
        }

        const onClickOverlay = () => {
            if (props.closeByOverlayTouch) {
                requestCloseDialog()
            }
        }

        const widthStyle = (): string => {

            if (typeof props.width === "number") {
                let w  = props.width
                if (w > window.innerWidth) {
                    w = window.innerWidth - 10
                }
                return w + "px"
            } else {
                return props.width
            }
        }

        const heightStyle = (): string => {
            if (typeof props.height === "number") {
                return props.height + "px"
            } else {
                return props.height
            }
        }

        onMounted(() => {
            isSM = window.innerWidth < 576
        })

        return {
            requestCloseDialog,
            onMouseDownInDialog,
            onClickOverlay,
            widthStyle,
            heightStyle,
        }
    },
})
</script>

<style scoped lang="scss">

    .fade-enter-active,
    .fade-leave-active {
        /* 表示されている際のCSSはこのブロックに記述 */
        transition: opacity .5s;
    }

    .fade-enter-from,
    .fade-leave-to {
        /* 非表示の際のCSSはこのブロックに記述 */
        opacity: 0;
    }

    .dialog-overlay {
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255, 255, 255, 0.5);
        z-index: 2000;
        overflow: hidden;

        .dialog {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 5px;
            box-shadow: 2px 2px 5px gray;
            backdrop-filter: blur(5px);
            overflow: hidden;

            .fill {
                min-height: 100%;
                height: 100%;
                width: 100%;
            }

            .dialog-header {
                color: white;
                background-color: orange;

                .dialog-title {
                    font-size: 20px;
                }
            }

            .close-button {
                position: absolute;
                margin: auto;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                width: 25px;
                height: 25px;

                &:hover {
                    opacity: 0.7;
                }

                &:active {
                    opacity: 0.3;
                }

                .close-x-button {
                    position: absolute;
                    width: 21px;
                    height: 21px;
                    border: 2px solid gray;
                    border-radius: 3px;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;

                    &::before {
                        content: "";
                        width: 16px;
                        height: 2px;
                        border-radius: 1px;
                        background-color: gray;
                        position: absolute;
                        left: 1px;
                        top: 8px;
                        transform: rotate(45deg);
                    }

                    &::after {
                        content: "";
                        width: 16px;
                        height: 2px;
                        border-radius: 1px;
                        background-color: gray;
                        position: absolute;
                        left: 1px;
                        top: 8px;
                        transform: rotate(-45deg);
                    }
                }
            }

            .dialog-content-row {
                width: 100%;
                height: calc(100% - 50px);
                //background-color: green;
            }

            .dialog-content {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
            }

        }
    }
</style>
